// Registration APIs used by the company owner onboarding flow.
import axiosApi, { postJson, requestJson } from "./axiosApi";

// Keep axiosApi imported here so this file always uses the centralized HTTP client layer.
void axiosApi;

// Ask backend to send registration OTP to the owner email address.
// Load the active platform plan catalogue from the same database table used by Super Admin.
export function getRegistrationPlans() {
  return requestJson("/registration/plans.php", { method: "GET" });
}

export function sendEmailOtp(email) {
  return postJson(
    "/registration/send_email_otp.php",
    { email },
    {
      includeErrorDetail: true,
      attachValidationErrors: true,
    },
  );
}

// Verify the registration OTP before allowing the owner to continue registration.
export function verifyEmailOtp(email, otp, registrationForm = {}) {
  return postJson(
    "/registration/verify_email_otp.php",
    { email, otp, registration_form: registrationForm },
    {
      includeErrorDetail: true,
      attachValidationErrors: true,
    },
  );
}

// Check duplicate company, email, mobile, GST, or other fields while the form is being filled.
export function checkRegistrationDuplicate(payload) {
  return postJson("/registration/check_duplicate.php", payload, {
    includeErrorDetail: true,
    attachValidationErrors: true,
  });
}

// Submit the final registration form and create the company owner account in backend.
export function submitRegistration(form) {
  return postJson("/registration/submit_registration.php", form, {
    includeErrorDetail: true,
    attachValidationErrors: true,
  });
}

// Restore in-progress owner registration after email OTP verification.
export function getRegistrationProgress() {
  return requestJson(
    "/registration/progress.php",
    { method: "GET" },
    {
      includeErrorDetail: true,
      attachValidationErrors: true,
    },
  );
}

// Persist current owner registration step/state in the temporary PHP session.
export function saveRegistrationProgress(payload) {
  return postJson("/registration/progress.php", payload, {
    includeErrorDetail: true,
    attachValidationErrors: true,
  });
}

// Clear temporary registration-only progress after completion or restart.
export function clearRegistrationProgress() {
  return postJson(
    "/registration/progress.php",
    { action: "clear" },
    {
      includeErrorDetail: true,
      attachValidationErrors: true,
    },
  );
}

export function createRazorpayOrder(plan, verificationToken = '', password = '') {
  return postJson('/registration/create_razorpay_order.php', { plan, email: window.sessionStorage.getItem('kaamdesk_registration_email') || '', verification_token: verificationToken, password }, { includeErrorDetail: true, attachValidationErrors: true });
}

export function verifyRazorpayPayment(payload, verificationToken = '') {
  return postJson('/registration/verify_razorpay_payment.php', { ...payload, email: window.sessionStorage.getItem('kaamdesk_registration_email') || '', verification_token: verificationToken }, { includeErrorDetail: true, attachValidationErrors: true });
}
